module.exports = __webpack_public_path__ + "img/2_2-industriale-centrale_elettrica-2.123df86b.png";